import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Card, Modal, Icon, withStyles } from 'vopay';
import { Title, CircleButton, Button } from 'UI';
import { useTranslation } from 'react-i18next';
import { AccountType } from '@/components/Accounts/AccountSummary/AccountSummaryPage';
import styles from './UpgradePlanModal.module.scss';

type UpgradePlanModalProps = {
  isVisible: boolean;
  accountType: AccountType;
  onCloseModal: () => void;
};

const cn = withStyles(styles);

const UpgradePlanModal: FC<UpgradePlanModalProps> = ({ isVisible, accountType, onCloseModal }) => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AccountBalances' });

  return (
    <Modal isVisible={isVisible} enableBgClick={false}>
      <Card
        style={{
          padding: '32px',
        }}
      >
        <div className={cn('modalContainer')}>
          <div className={cn('closeButton')}>
            <CircleButton icon="close" size="large" circleFill onClick={onCloseModal} />
          </div>
          <Title level="4">{t('upgradePlanTitle')}</Title>
          <p className={cn('description')}>{t('upgradePlanInfo')}</p>
          <Box gapSize="18px">
            {accountType !== 'standard' && (
              <div className={cn('plan', 'standard')}>
                <Icon icon="clock" width="84px" height="84px" color="none" />
                <Box flx="col" gap="sm" ai="center">
                  <Title level="6">{t('standardTitle')}</Title>
                  <p>{t('standardInfo')}</p>
                </Box>
              </div>
            )}
            <div className={cn('plan', 'premium')}>
              <Icon icon="calendarPremium" width="84px" height="84px" color="none" />
              <Box flx="col" gap="sm" ai="center">
                <Title className={cn('title')} level="6">
                  {t('premiumTitle')}
                </Title>
                <p>{t('premiumInfo')}</p>
              </Box>
            </div>
          </Box>

          <Button
            className={cn('button')}
            colorScheme="primary"
            onClick={() => {
              history.push('/create-tickets');
            }}
          >
            {t('contactSupportButton')}
          </Button>
        </div>
      </Card>
    </Modal>
  );
};

export default UpgradePlanModal;
